import { DocumentStatusBadge } from '#/modules/commonComponents/badge';
import { formatDateOrDash } from '#/utils/date';

function resolveCategoryLabel(category) {
  if (!category) {
    return '-';
  }

  return [category.code, category.name].filter(Boolean).join(' ') || '-';
}

/** Block A：僅狀態 */
export const stockIssueSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          <DocumentStatusBadge status={row?.status} size="default" />
        </div>
      ),
    },
  ],
};

/** Block C+：其餘欄位 */
export const stockIssueSideMsgDetailBlock = {
  fields: [
    { label: '出庫單號', value: 'issueNo' },
    {
      label: '出庫日',
      value: (row) => formatDateOrDash(row?.issueDate),
    },
    {
      key: 'category',
      label: '出庫類別',
      value: (row) => resolveCategoryLabel(row?.category),
    },
    {
      label: '物料項目數',
      value: (row) => {
        if (Array.isArray(row?.lines)) {
          return row.lines.length;
        }
        if (row?.lineCount != null && row.lineCount !== '') {
          return row.lineCount;
        }
        return '—';
      },
    },
    { label: '備註', value: 'remark' },
  ],
};

export const stockIssueSideMsgBlocks = [
  stockIssueSideMsgStatusBlock,
  stockIssueSideMsgDetailBlock,
];
